import firebase from 'firebase/app'
import 'firebase/database'

const config = {
  apiKey: 'AIzaSyDkibsm99MBF1-mIRUf-7eraurjmNKAL0Y',
  authDomain: 'healthview-homehealth-c89m.firebaseapp.com',
  databaseURL: 'https://healthview-homehealth-c89m.firebaseio.com',
  projectId: 'healthview-homehealth-c89m',
  storageBucket: 'healthview-homehealth-c89m.appspot.com',
  messagingSenderId: '800081952898',
}

if (!firebase.apps.length) firebase.initializeApp(config)

export const db = firebase.database()
export default firebase
